"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECTED_RESOLUTION_REVIEWER_ID = void 0;
exports.readPinout = readPinout;
exports.readParameters = readParameters;
exports.resolutionToGeneralPayload = resolutionToGeneralPayload;
exports.extractResolutionAnchors = extractResolutionAnchors;
exports.projectResolutionToSliceTables = projectResolutionToSliceTables;
const consensus_types_1 = require("./consensus.types");
const confidence_policy_1 = require("./confidence-policy/confidence-policy");
const triage_policy_1 = require("./triage-policy/triage-policy");
exports.PROJECTED_RESOLUTION_REVIEWER_ID = '__ground_truth__';
function isRowRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function readPinout(pins) {
    const pinout = {};
    for (const pin of pins) {
        if (pin.signalRef === null || pin.signalRef === undefined) {
            continue;
        }
        pinout[pin.signalRef] ??= [];
        pinout[pin.signalRef].push(pin.name);
    }
    return pinout;
}
function readParameters(sigmaModelParameters) {
    const parameters = {};
    for (const [key, valueVariance] of Object.entries(sigmaModelParameters)) {
        parameters[key] = {
            value: valueVariance.value === undefined ? null
                : typeof valueVariance.value === 'number' ? String(valueVariance.value)
                    : valueVariance.value,
            variance: valueVariance.variance ?? null,
        };
    }
    return parameters;
}
function resolutionToGeneralPayload(sigmaModelType, resolution) {
    return {
        sigmaModelType,
        signals: resolution.signals ?? [],
        parameters: readParameters(resolution.sigmaModelParameters ?? {}),
        pinout: readPinout(resolution.pins ?? []),
        boundaries: resolution.boundaries ?? [],
        resources: resolution.resources ?? [],
        functions: resolution.functions ?? [],
        modes: resolution.modes ?? [],
        spiceModels: resolution.spiceModels ?? [],
    };
}
const PROJECTION_POLICIES = {
    confidencePolicy: new confidence_policy_1.ProportionalConfidencePolicy({ minReviewers: 1 }),
    triagePolicy: new triage_policy_1.ThresholdTriagePolicy(1),
};
function extractResolutionAnchors(slices, payload, logger) {
    const bySlice = new Map();
    for (const slice of slices) {
        if (!slice.appliesTo([payload])) {
            continue;
        }
        const assembly = slice.run([[exports.PROJECTED_RESOLUTION_REVIEWER_ID, payload]], PROJECTION_POLICIES, logger);
        const rowKeys = new Set();
        const rowContentByRowKey = new Map();
        const fieldNormalizedByAnchorKey = new Map();
        const fieldRawByAnchorKey = new Map();
        const fieldRowKeyByAnchorKey = new Map();
        const fieldColumnByAnchorKey = new Map();
        for (const tally of assembly.annotations) {
            if (tally.anchor.kind === consensus_types_1.AnchorKind.Row) {
                rowKeys.add(tally.anchor.rowKey);
                const representative = tally.candidates[0]?.value;
                if (isRowRecord(representative)) {
                    rowContentByRowKey.set(tally.anchor.rowKey, representative);
                }
                continue;
            }
            const candidate = tally.candidates[0];
            if (candidate === undefined) {
                continue;
            }
            const key = (0, consensus_types_1.anchorKey)(tally.anchor);
            fieldNormalizedByAnchorKey.set(key, candidate.normalizedValue);
            fieldRawByAnchorKey.set(key, candidate.value);
            fieldRowKeyByAnchorKey.set(key, tally.anchor.rowKey);
            fieldColumnByAnchorKey.set(key, tally.anchor.column);
        }
        bySlice.set(slice.sliceKey, {
            sliceKey: slice.sliceKey,
            rowKeys,
            rowContentByRowKey,
            fieldNormalizedByAnchorKey,
            fieldRawByAnchorKey,
            fieldRowKeyByAnchorKey,
            fieldColumnByAnchorKey,
        });
    }
    return bySlice;
}
function projectResolutionToSliceTables(slices, payload, logger) {
    const bySlice = new Map();
    for (const slice of slices) {
        if (!slice.appliesTo([payload])) {
            continue;
        }
        const assembly = slice.run([[exports.PROJECTED_RESOLUTION_REVIEWER_ID, payload]], PROJECTION_POLICIES, logger);
        bySlice.set(slice.sliceKey, assembly.table);
    }
    return bySlice;
}
//# sourceMappingURL=resolution-projection.js.map